import type { CreateUserResult } from "@/lib/api";
import { DialogFrame } from "@/components/common/DialogFrame";
import { InviteLinkShare } from "@/components/admin/InviteLinkShare";

interface InviteLinkDialogProps {
	open: boolean;
	invite: CreateUserResult | null;
	onClose: () => void;
}

export function InviteLinkDialog({ open, invite, onClose }: InviteLinkDialogProps) {
	if (!invite) return null;

	return (
		<DialogFrame
			open={open}
			title="招待リンクを再発行しました"
			width={480}
			onClose={onClose}
			footer={
				<button
					type="button"
					onClick={onClose}
					style={{
						height: 34,
						padding: "0 16px",
						background: "var(--accent-solid)",
						color: "var(--on-neutral-solid)",
						border: 0,
						borderRadius: "var(--radius-3)",
						fontSize: "var(--text-ui)",
						fontWeight: 500,
						fontFamily: "var(--font-sans)",
						cursor: "pointer",
					}}
				>
					閉じる
				</button>
			}
		>
			<div
				style={{
					padding: "10px 14px",
					borderRadius: "var(--radius-3)",
					background: "var(--warning-subtle)",
					boxShadow: "0 0 0 1px var(--warning-line)",
					fontSize: "var(--text-ui)",
					color: "var(--warning)",
					fontFamily: "var(--font-sans)",
					lineHeight: "var(--leading-normal)",
				}}
			>
				以前のリンクは無効になりました。新しいリンクは7日後に失効します。
			</div>
			<InviteLinkShare key={invite.inviteId} userId={invite.id} inviteUrl={invite.inviteUrl} />
		</DialogFrame>
	);
}
